<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="mb-5">
          <div class="txt-head black--text mb-2">
            <span class="theme-color-one">ส่วนที่ 1 :</span>
            ผลการดำเนินโครงการและร้อยละการดำเนินงาน
          </div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              1. ผลการดำเนินโครงการ
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button
              v-if="!isFinal"
              theme="6"
              :disabled="partTwoEditMode"
              @onClick="addNewBudget"
            >
              + เพิ่มรายละเอียดงบประมาณ
            </Button>
          </div>

          <div class="d-flex theme-color-eight px-3 mb-3 gap-12">
            <div style="width: 8%">{{ isFinal ? "" : "จัดการ" }}</div>
            <div style="width: 10%">รายการ</div>
            <div style="width: 22%">รายละเอียด</div>
            <div class="text-end" style="width: 15%">ได้รับอนุมัติ</div>
            <div class="text-end" style="width: 15%">เบิกจ่ายแล้ว</div>
            <div class="text-end" style="width: 15%">คงเหลือ</div>
            <div class="text-end" style="width: 15%">หมายเหตุ</div>
          </div>

          <div class="d-flex flex-column gap-16">
            <div v-for="(item, i) in budgetList" :key="i" class="budget-item">
              <div
                class="d-flex justify-space-between align-center black--text gap-12"
              >
                <div style="width: 8%">
                  <v-btn v-if="!isFinal" small icon @click="editBudget(i)">
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                  <v-btn v-if="!isFinal" small icon @click="deleteBudget(i)">
                    <Iconify
                      icon="material-symbols:delete"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div style="width: 10%">{{ item.budget_name }}</div>
                <div
                  style="width: 22%"
                  v-html="item.budget_detail?.replace(/\n/g, '<br>')"
                ></div>
                <div class="text-end" style="width: 15%">
                  {{ formatNumber(item.approved_budget, 2) }}
                </div>
                <div class="text-end" style="width: 15%">
                  {{ formatNumber(item.disbursed_budget, 2) }}
                </div>
                <div class="text-end" style="width: 15%">
                  {{ formatNumber(item.remaining_budget, 2) }}
                </div>
                <div class="text-end" style="width: 15%">
                  {{ item.remarks || "-" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="partTwoEditMode && !isFinal"
        id="part-two-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-2" style="align-items: end">
          <div>
            <div class="black--text mb-3">ชื่อกิจกรรม</div>

            <TextField
              theme="3"
              :value="tempBudget.budget_name"
              @onChange="tempBudget.budget_name = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">ได้รับอนุมัติ</div>
            <TextField
              theme="3"
              input-type="decimal"
              isFormat
              :value="tempBudget.approved_budget"
              @onChange="tempBudget.approved_budget = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">เบิกจ่ายแล้ว</div>
            <TextField
              theme="3"
              input-type="decimal"
              isFormat
              :value="tempBudget.disbursed_budget"
              @onChange="tempBudget.disbursed_budget = $event"
            ></TextField>
          </div>

          <div>
            <div class="black--text mb-3">คงเหลือ</div>

            <TextField
              theme="3"
              input-type="decimal"
              isFormat
              disabled
              readonly
              :value="tempBudget.remaining_budget"
              @onChange="tempBudget.remaining_budget = $event"
            ></TextField>
          </div>
        </div>

        <div>
          <div>
            <div class="black--text mb-2">รายละเอียด</div>

            <TextArea
              theme="3"
              :value="tempBudget.budget_detail"
              @onChange="tempBudget.budget_detail = $event"
            ></TextArea>
          </div>
          <div>
            <div class="black--text mb-2">วิธีการดำเนินการ</div>

            <TextField
              theme="3"
              :value="tempBudget.procedure"
              @onChange="tempBudget.procedure = $event"
            ></TextField>
          </div>
          <div>
            <div class="black--text mb-2">ผลการดำเนินการ</div>

            <TextField
              theme="3"
              :value="tempBudget.result"
              @onChange="tempBudget.result = $event"
            ></TextField>
          </div>
          <div>
            <div class="black--text mb-2">หมายเหตุ</div>

            <TextField
              theme="3"
              :value="tempBudget.remarks"
              @onChange="tempBudget.remarks = $event"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partTwoEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudget"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>

    <divcard>
      <div class="card-part pt-0">
        <!-- Form 2 -->
        <div>
          <div class="txt-head black--text d-flex justify-space-between mb-3">
            <div>
              2. ร้อยละการดำเนินงาน
              <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
            </div>
            <Button theme="6" :disabled="partOneEditMode" @onClick="addNewPlan">
              + เพิ่มกิจกรรม
            </Button>
          </div>

          <!--   PLAN HEADERS   -->
          <div class="py-5 overflow-x-auto mx-n6 px-6 scroll">
            <div class="d-flex justify-space-between gap-8 px-3 mb-3">
              <div class="flex" style="min-width: 42px; max-width: 42px">
                จัดการ
              </div>
              <div class="flex" style="min-width: 120px; max-width: 120px">
                กิจกรรม
              </div>
              <div class="flex" style="min-width: 18px; max-width: 18px">
                <!-- WF -->
              </div>
              <div
                v-for="(m, ind) in shortMonths"
                :key="ind"
                class="flex"
                style="min-width: 43px; max-width: 43px"
              >
                <div class="text-center">{{ m.month }}</div>
                <div class="text-center">{{ m.year }}</div>
              </div>
            </div>

            <!--   PLAN ITEMS   -->
            <div
              v-if="allPlans && allPlans.length > 0"
              class="d-flex flex-column gap-12"
            >
              <div
                v-for="(item, i) in allPlans"
                :key="i"
                class="plan-card d-flex justify-space-between gap-8"
                :class="{
                  'plan-active':
                    partOneEditMode && tempPlan && tempPlan.temp_index === i,
                }"
              >
                <div
                  class="d-flex justify-space-between align-center"
                  style="min-width: 42px; max-width: 42px"
                >
                  <v-btn small icon @click="editPlan(i)">
                    <Iconify
                      icon="material-symbols:edit"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                  <v-btn small icon @click="deletePlan(i)">
                    <Iconify
                      icon="material-symbols:delete"
                      color="var(--theme-color-seven)"
                    ></Iconify>
                  </v-btn>
                </div>
                <div class="d-block">
                  <div
                    class="flex two-line"
                    style="min-width: 120px; max-width: 120px; max-height: 45px"
                  >
                    <tooltip-text :text="item.p1_activity_name" />
                  </div>
                </div>
                <div
                  class="flex d-flex justify-space-between"
                  style="min-width: 18px; max-width: 18px; height: 54px"
                >
                  <v-divider vertical></v-divider>
                </div>
                <div
                  v-for="(m, ind) in item.project_section_plan_month"
                  :key="ind"
                  class="flex d-flex flex-column gap-8"
                  style="min-width: 43px; max-width: 43px"
                >
                  <div class="tiny-field">
                    {{ m.month_value ? m.month_value : "-" }}
                  </div>
                  <div v-if="isFinal" class="tiny-field">
                    {{ m.actual_month_value ? m.actual_month_value : "-" }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
          </div>
        </div>
      </div>

      <div v-if="partOneEditMode" id="part-one-edit" class="card-part">
        <div class="d-flex gap-16 mb-3">
          <div>
            <div class="black--text mb-3">กิจกรรม</div>

            <TextField
              theme="3"
              :value="tempPlan.p1_activity_name"
              @onChange="tempPlan.p1_actvity_name = $event"
            ></TextField>
          </div>
        </div>

        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              theme="3"
              input-type="decimal-100"
              :error="
                tempPlan.project_section_plan_month[i]?.error ||
                tempPlan.project_section_plan_month[i]?.errorSkipInput
              "
              :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="
                isFinal
                  ? tempPlan.project_section_plan_month[i]?.actual_month_value
                  : tempPlan.project_section_plan_month[i]?.month_value
              "
              @onChange="validateInput(i, $event)"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button min-width="80px" theme="2" @onClick="partOneEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="savePlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
      <div
        v-if="partOneBudgetEditMode"
        id="part-one-budget-edit"
        class="card-part"
      >
        <div class="d-flex gap-16 mb-3">
          {{ isFinal ? "การใช้จ่ายจริง" : "แผนการใช้จ่าย" }}
          <span class="theme-color-seven txt-normal" style="margin-left: 22px"
            >(บาท)</span
          >
        </div>

        <div class="plan-field-form">
          <div v-for="(month, i) in shortMonths" :key="i">
            <div class="text-center mb-2">
              {{ month.month }} {{ month.year }}
            </div>
            <TextField
              v-if="isFinal"
              theme="3"
              input-type="decimal"
              :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="tempBudgetPlan[i]?.use_budget"
              @onChange="tempBudgetPlan[i].use_budget = $event"
            ></TextField>
            <TextField
              v-else
              theme="3"
              input-type="decimal"
              isFormat
              :disabled="nowIndex(month.month, month.year)"
              :readonly="nowIndex(month.month, month.year)"
              :value="tempBudgetPlan[i]?.plan_budget"
              @onChange="tempBudgetPlan[i].plan_budget = $event"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end gap-16">
          <Button
            min-width="80px"
            theme="2"
            @onClick="partOneBudgetEditMode = false"
            >ยกเลิก
          </Button>

          <Button min-width="80px" theme="6" @onClick="saveBudgetPlan"
            >ยืนยัน
          </Button>
        </div>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import TextArea from "../../../components/input/TextArea";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import Button from "../../../components/input/Button";
import CheckBox from "../../../components/input/CheckBox";
import { eventBus, formatNumber } from "../../../plugins/global-funcs";
import { mapState } from "vuex";
import { format } from "date-fns";
import { th } from "date-fns/locale";

export default {
  name: "FundamentalFormResult",
  components: {
    TextField,
    TextArea,
    SwitchInset,
    AutoBox,
    CheckBox,
    Button,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      formatNumber,
      form: {},
      tempPlan: {},
      tempBudgetPlan: {},
      tempBudget: {
      },
      tempOA: {},
      tempProgressPlan: {},
      partOneEditMode: false,
      partOneBudgetEditMode: false,
      partTwoEditMode: false,
      expanded: false,
      allPlans: [],
      budgetPlans: [],
      shortMonths: [],
      plan_prototype: {
        p1_wf: "",
        project_section_plan_month: [],
      },
      budget_plan_prototype: [],
      progressPlan_prototype: {
        plan: [],
      },
      error_p1_wf: false,
      allProgressPlan: [],
      budgetList: [],
      currIndex: 0,
      budget_amount: 0,
      fiscalYear: new Date().getFullYear() + 543,
    };
  },
  computed: {
    ...mapState({
      PlanForm: (state) => state.AForm.PlanForm,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created() {
    this.clearTempPlan();
    this.clearTempProgressPlan();
    if (this.masterData) {
      this.setData();
    }

    this.setupBudgetYearMonth();
    if (this.budgetPlans.length === 0) {
      this.budgetPlans = this.budget_plan_prototype;
    }

    eventBus.$on("fundamentalFormResult", () => {
      eventBus.$emit("fundamentalFormResultSend", {
        project_section_plan: {
          project_section_plan_p1: this.allPlans.map((x) => ({
            id: x.id || null,
            p1_activity_name: x.p1_activity_name,
            project_section_plan_month: x.project_section_plan_month.map(
              (y) => ({
                id: y.id || null,
                month_value: y.month_value ? parseFloat(y.month_value) : null,
                year_month: y.year_month,
              })
            ),
          })),
        },
        fund_budgets: this.budgetList.map((x) => ({
          id: x.id || null,
          budget_name: x.budget_name,
          form_fund_id: this.$route.query.id,
          approved_budget: x.approved_budget,
          disbursed_budget: x.disbursed_budget,
          remaining_budget: x.remaining_budget,
          budget_detail: x.budget_detail,
          procedure: x.procedure,
          result: x.result,
          remarks: x.remarks
        })),
      });
    });

    this.currIndex = this.getCurrIndex();
    eventBus.$on("fundamentalFormResultSetData", () => this.setData());
  },
  methods: {
    setData() {
      console.log("setData FundamentalFormResult", this.masterData);

      this.allPlans =
        this.masterData.formFund?.project_section_plan?.project_plan_p1 || [];

      for (const x of this.allPlans) {
        x.percent = this.getLastProgress(x.project_section_plan_month);
      }
      this.budgetList = this.masterData.formFund?.fund_budgets || [];
      this.fiscalYear = this.masterData.formFund?.fiscal_year;
      this.calcBudgetAmount();
    },
    addNewPlan() {
      // clear temp index
      this.clearTempPlan();
      if (this.partOneEditMode) {
        this.$vuetify.goTo("#part-one-edit");
      } else {
        this.tempPlan.isNew = true;
        this.partOneEditMode = true;
      }
    },
    editPlan(i) {
      this.partOneEditMode = false;
      this.tempPlan = {
        ...this.removeVModel(this.allPlans[i]),
        temp_index: i,
      };
      this.partOneEditMode = true;
      this.$forceUpdate();
    },
    deletePlan(i) {
      console.log("deletePlan", i);
      this.allPlans.splice(i, 1);
      this.$forceUpdate();
    },
    savePlan() {
      // complete 2 pos decimal format
      this.completeTwoPosDecimal("tempPlan");

      // validate WF
      // if (!this.validateWF()) return;

      // validate conditions
      let before_value = 0;
      let error = [];
      let field_name = "month_value";
      for (const x of this.tempPlan.project_section_plan_month) {
        if (this.isFinal) field_name = "actual_month_value";
        if (!isNaN(x[field_name]) && parseFloat(x[field_name]) < before_value) {
          x.error = true;
          if (this.isFinal) {
            error.push(
              "Value must be greater than previous actual month value"
            );
          } else {
            error.push("Value must be greater than previous month value");
          }
        } else {
          x.error = undefined;
          if (x.errorSkipInput) {
            error.push("Cannot skip the input between input values");
          }
        }
        before_value = parseFloat(x[field_name]);
      }
      this.$forceUpdate();
      if (error.length > 0) {
        console.log(error);
        return;
      }

      let lastProgress = this.getLastProgress(
        this.tempPlan.project_section_plan_month
      );
      if (!this.tempPlan.isNew) {
        // EDIT
        this.allPlans[this.tempPlan.temp_index] = {
          ...this.tempPlan,
          percent: lastProgress,
          temp_index: undefined,
        };
      } else {
        // ADD
        this.allPlans.push({
          p1_activity_name: this.tempPlan.p1_actvity_name,
          p1_wf: this.tempPlan.p1_wf,
          project_section_plan_month: this.tempPlan.project_section_plan_month,
          percent: lastProgress,
        });
      }

      this.clearTempPlan();
      this.partOneEditMode = false;
    },
    clearTempPlan() {
      this.tempPlan = this.removeVModel(this.plan_prototype);
      this.error_p1_wf = false;
      this.$forceUpdate();
    },
    removeVModel(item) {
      return JSON.parse(JSON.stringify(item));
    },
    getLastProgress(items) {
      items = this.removeVModel(items);
      if (items && typeof items === "object" && items.length > 0) {
        for (const x of items.reverse()) {
          if (!!x.month_value && x.month_value !== "-") {
            return x.month_value;
          }
        }
      }
      return "-";
    },
    completeTwoPosDecimal(tempName) {
      let i = 0;
      let temp = [];
      let value = "";
      if (tempName === "tempPlan") {
        temp = this[tempName].project_section_plan_month;
        value = this.isFinal ? "actual_month_value" : "month_value";
      } else {
        temp = this[tempName];
        value = this.isFinal ? "use_budget_rate" : "plan_budget_rate";
      }

      for (const x of temp) {
        x.errorSkipInput = undefined;
        if (!x[value] || isNaN(x[value])) {
          x[value] = null;
          if (i > 0) {
            let hasSomeProgressBefore = false;
            let hasSkipInput = false;
            for (let ind = 0; ind < i; ind++) {
              if (temp[ind][value]) {
                hasSomeProgressBefore = true;
                for (let lastInd = temp.length - 1; lastInd > i; lastInd--) {
                  if (!!temp[lastInd][value]) hasSkipInput = true;
                }
              }
            }

            if (hasSomeProgressBefore) x[value] = "100.00";
            if (tempName === "tempBudgetPlan") x[value] = "0";

            if (hasSkipInput) {
              x[value] = null;
              x.errorSkipInput = true;
            }
          }
        } else {
          // no decimal case
          if (!x[value].toString().includes(".")) {
            x[value] += ".00";
          } else {
            // decimal case
            let y = x[value].toString().split(".");
            if (!y[0] && y[0] != "0") {
              y[0] = "0";
            }
            if (!y[1] && y[1] != "0") {
              y[1] = "00";
            }
            // fill zero for 2 position decimal
            if (y.length > 1 && y[1].length === 1) {
              y[1] = y[1].toString() + "0"; // add 0 as string
            }
            // remove after 2 position decimal
            if (y.length > 1 && y[1].length > 2) {
              y[1] = y[1].substring(0, 2);
            }
            x[value] = y[0] + "." + y[1];
            if (x[value] === "0.00") x[value] = null;
          }
        }
        i++;
      }
    },
    validateWF() {
      let error = [];
      let total = 0;
      let editCase =
        !!this.tempPlan.temp_index || this.tempPlan.temp_index === 0;

      // total is 1.00
      if (this.allPlans.length > 0) {
        if (this.allPlans.length === 1) {
          total = this.allPlans[0].p1_wf;
          if (editCase) total = 0;
        } else {
          if (editCase) {
            total = this.allPlans
              .filter((x, i) => i !== this.tempPlan.temp_index)
              .map((x) => x.p1_wf)
              .reduce((a, b) => parseFloat(a) + parseFloat(b), 0);
          } else {
            total = this.allPlans.reduce(
              (a, b) => parseFloat(a.p1_wf) + parseFloat(b.p1_wf),
              0
            );
          }
        }

        if (parseFloat(total) >= 1) {
          error.push("WF value cannot over exceed 1.00");
        }
      }

      if (!this.tempPlan.p1_wf || isNaN(this.tempPlan.p1_wf)) {
        error.push("WF value is not correct");
      } else {
        // no decimal case
        if (!this.tempPlan.p1_wf.toString().includes(".")) {
          this.tempPlan.p1_wf += ".00";
        } else {
          // decimal case
          let y = this.tempPlan.p1_wf.toString().split(".");
          if (!y[0] && y[0] != "0") {
            y[0] = "0";
          }
          if (!y[1] && y[1] != "0") {
            y[1] = "00";
          }
          // fill zero for 2 position decimal
          if (y.length > 1 && y[1].length === 1) {
            y[1] = y[1].toString() + "0"; // add 0 as string
          }
          // remove after 2 position decimal
          if (y.length > 1 && y[1].length > 2) {
            y[1] = y[1].substring(0, 2);
          }
          this.tempPlan.p1_wf = y[0] + "." + y[1];
          if (this.tempPlan.p1_wf === "0.00") {
            error.push("WF value is not correct");
          }
        }
        if (this.tempPlan.p1_wf > 1) {
          error.push("WF value must less or equal 1.00");
        }
      }

      if (parseFloat(total) + parseFloat(this.tempPlan.p1_wf) > 1) {
        error.push("WF total value must equal 1.00");
      }

      if (error.length > 0) {
        console.log(error);
        this.error_p1_wf = true;
      } else {
        this.error_p1_wf = false;
      }
      this.$forceUpdate();

      return !this.error_p1_wf;
    },
    weightPlan(index, field = "month_value") {
      let total = [];
      for (const x of this.allPlans) {
        let result = x.project_section_plan_month[index]
          ? parseFloat(x.project_section_plan_month[index][field] * x.p1_wf)
          : 0;
        if (!isNaN(result)) {
          total.push(result);
        }
      }
      if (total.length > 0) {
        total = total.reduce((a, b) => a + b, 0);
      } else {
        total = "-";
      }
      if (typeof total === "number") return total.toFixed(2);
      return total;
    },
    getCurrIndex() {
      let ind = 0;
      for (const x of this.allPlans) {
        let i = 0;
        // console.log("x", x);
        for (const y of x.project_section_plan_month) {
          // console.log("y", y);
          let correctIndex = this.isInCorrectRange(y, i);
          if (typeof correctIndex !== "boolean") return correctIndex;
          i++;
        }
        ind++;
      }
    },
    isInCorrectRange(item, index = null) {
      let today = new Date();
      let currentMonth = today.getMonth();
      let thisMonth = new Date(item.year_month).getMonth();

      let isCorrectCase = thisMonth === currentMonth;

      // for return active yearMonth index
      if (isCorrectCase && index !== null) return index;

      return isCorrectCase;
    },
    addNewBudget() {
      this.tempBudget = {
      };
      if (this.partTwoEditMode) {
        // clear temp index
        // this.clearTempPlan()

        this.$vuetify.goTo("#part-two-edit");
      } else {
        // this.tempPlan.isNew = true
        this.partTwoEditMode = true;
      }
    },
    editBudget(index) {
      this.tempBudget = {
        ...this.removeVModel(this.budgetList[index]),
        temp_index: index,
      };

      this.partTwoEditMode = true;
    },
    deleteBudget(index) {
      this.budgetList.splice(index, 1);
      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
    },
    saveBudget() {
      this.partTwoEditMode = false;
      //this.tempBudget.budget_sum = parseFloat(this.tempBudget.budget_in_kind) + parseFloat(this.tempBudget.budget_in_cash) + parseFloat(this.tempBudget.budget_sci_park)
      this.tempBudget.remaining_budget =
        parseFloat(this.tempBudget.approved_budget) -
        parseFloat(this.tempBudget.disbursed_budget);

      if (isNaN(this.tempBudget.approved_budget))
        this.tempBudget.approved_budget = 0;

      if (this.tempBudget.temp_index !== undefined) {
        this.budgetList[this.tempBudget.temp_index] = this.removeVModel(
          this.tempBudget
        );
      } else {
        this.budgetList.push(this.tempBudget);
      }
      this.tempBudget = {};

      this.calcBudgetAmount();
      this.calcBudgetPlanRate("budgetPlans");
      this.$forceUpdate();
    },
    clearTempProgressPlan() {
      this.tempProgressPlan = this.removeVModel(this.progressPlan_prototype);
      this.$forceUpdate();
    },
    setupBudgetYearMonth() {
      if (!this.fiscalYear) {
        this.fiscalYear = new Date().getFullYear() + 543;
      }

      let ym = new Date((this.fiscalYear - 544).toString() + "-10");
      for (let i = 0; i < 12; i++) {
        this.shortMonths.push({
          key: i + 1,
          month: format(ym, "MMM", { locale: th }),
          year: (parseInt(ym.toISOString().substr(0, 7).split("-")[0]) + 543)
            .toString()
            .slice(2),
        });
        this.plan_prototype.project_section_plan_month.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
        });
        this.budget_plan_prototype.push({
          year_month: ym.toISOString().substr(0, 7),
          month_value: "",
          plan_budget: "",
          plan_budget_rate: "",
        });
        ym = new Date(ym.setMonth(ym.getMonth() + 1));
      }
    },
    calcBudgetAmount() {
      // console.log("budget", this.budgetList);
      this.budget_amount = this.budgetList
        .map((x) => parseFloat(x.approved_budget))
        .reduce((a, b) => a + b, 0);
      // console.log("budget_amount", this.budget_amount);
    },
    saveBudgetPlan() {

      this.calcBudgetPlanRate();
      // complete 2 pos decimal format
      // this.completeTwoPosDecimal('tempBudgetPlan')

      // validate conditions
      let before_value = 0;
      let totalBudget = 0;
      let error = [];
      for (const x of this.tempBudgetPlan) {
        before_value = parseFloat(x.plan_budget);
        totalBudget += parseFloat(x.plan_budget);
      }
      this.$forceUpdate();
      if (totalBudget > this.budget_amount && !this.isFinal) {
        this.$store.commit("General/setModal", {
          theme: "error",
          title: "บันทึกไม่สำเร็จ",
          text: "แผนการใช้จ่ายเกินงบประมาณ ไม่สามารถบันทึกได้",
          buttonText: "OK",
          showCancel: false,
        });
        return;
      }
      if (error.length > 0) {
        console.log(error);
        return;
      }

      this.budgetPlans = this.tempBudgetPlan;

      this.partOneBudgetEditMode = false;
    },
    calcBudgetPlanRate(objectName = "tempBudgetPlan") {
      let i = 0;
      let field_name =
        this.isFinal && objectName === "tempBudgetPlan"
          ? "use_budget"
          : "plan_budget";
      this[objectName].forEach((budget) => {
        if (!budget[field_name]) budget[field_name] = 0;
        if (i == 0) {
          budget[field_name + "_sum"] = parseFloat(budget[field_name]);
        } else {
          budget[field_name + "_sum"] =
            parseFloat(budget[field_name]) +
            parseFloat(this[objectName][i - 1][field_name + "_sum"]);
        }
        const exactRate = (parseFloat(budget[field_name + "_sum"]) / parseFloat(this.budget_amount)) * 100;

        budget[field_name + "_rate"] = (Math.floor(exactRate * 100) / 100).toFixed(2);
        budget[field_name + "_sum"] = budget[field_name + "_sum"].toFixed(2);
        i++;
      });
      console.log("after calc budget rate", this.tempBudgetPlan);
    },
    validateInput(index, value) {
      let field_name = "month_value";
      if (this.isFinal) field_name = "actual_month_value";
      if (!isNaN(value) && value >= 0 && value <= 100) {
        // if (index > 0) {
        //   let previousValue = this.tempPlan.project_section_plan_month[index - 1]?.month_value;
        //   if (previousValue && value >= previousValue) {
        //     this.$set(this.tempPlan.project_section_plan_month[index], 'month_value', value);
        //   } else {
        //     this.$set(this.tempPlan.project_section_plan_month[index], 'month_value', previousValue);
        //   }
        // } else {
        this.$set(
          this.tempPlan.project_section_plan_month[index],
          field_name,
          value
        );
        // }
      } else {
        if (!isNaN(value)) {
          if (value > 100) {
            this.$set(
              this.tempPlan.project_section_plan_month[index],
              field_name,
              100
            );
          } else {
            this.$set(
              this.tempPlan.project_section_plan_month[index],
              field_name,
              0
            );
          }
        } else {
          this.$set(
            this.tempPlan.project_section_plan_month[index],
            field_name,
            null
          );
        }
      }
    },
    nowIndex(month, year) {
      const thaiShortMonthMap = {
        "ม.ค.": 0,
        "ก.พ.": 1,
        "มี.ค.": 2,
        "เม.ย.": 3,
        "พ.ค.": 4,
        "มิ.ย.": 5,
        "ก.ค.": 6,
        "ส.ค.": 7,
        "ก.ย.": 8,
        "ต.ค.": 9,
        "พ.ย.": 10,
        "ธ.ค.": 11,
      };
      const monthNumber = thaiShortMonthMap[month];
      if (monthNumber === undefined) return false; // fail-safe

      const buddhistYear = parseInt(year); // 68
      const gregorianYear = buddhistYear + 2000 - 543; // 68 + 2000 - 543 = 1525 (wrong) ❌

      // Correct conversion:
      const currentYear = new Date().getFullYear(); // e.g., 2025
      const buddhistCurrentYear = currentYear + 543; // e.g., 2568

      const yearFull =
        buddhistYear > 2500 ? buddhistYear - 543 : buddhistYear + 2500 - 543;
      // Or easier if always 2-digit: assume 68 => 2568 => 2025
      const yearParsed = buddhistYear + 2500 - 543; // 2025

      const planDate = new Date(yearParsed, monthNumber, 1);
      const currentMonthStart = new Date();
      currentMonthStart.setDate(1);
      currentMonthStart.setHours(0, 0, 0, 0);

      return planDate < currentMonthStart;
    },
  },
};
</script>

<style scoped lang="scss">
.budget-item,
.summary-plan {
  background: #ffffff;
  box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px;
  border: solid 1px transparent;
  cursor: pointer;
}

.budget-item-active {
  border-color: var(--theme-color-seven);
}

.summary-plan {
  min-height: 78px;
}

.remark-box {
  color: var(--theme-color-seven);
  background: #fafafa;
  border-radius: 20px;
  padding: 12px;
  font-size: 10px;
}

.plan-card {
  background: #ffffff;
  box-shadow: 1px 1px 18px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  border: 1px solid transparent;
  padding: 12px;
  min-width: max-content;
  &.plan-active {
    border: 1px solid var(--theme-color-seven);
  }
}

.plan-field-form {
  /* User input values. */
  --grid-layout-gap: 16px;
  --grid-column-count: 6;
  --grid-item--min-width: 130px;

  /* Calculated values. */
  --gap-count: calc(var(--grid-column-count) - 1);
  --total-gap-width: calc(var(--gap-count) * var(--grid-layout-gap));
  --grid-item--max-width: calc(
    (100% - var(--total-gap-width)) / var(--grid-column-count)
  );

  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap: var(--grid-layout-gap);
}

.plan-slot > div {
  transition: background-color 400ms;
  background-color: #fff;
  height: 20px;
}
.plan-slot .progress-plan-mark {
  background-color: var(--theme-color-one);
  min-width: 45px;
  display: flex;
  align-items: center;
  padding-top: 1px;
  .v-divider {
    border-color: #fff;
  }
}

.progress-plan-mark.start-point {
  border-radius: 30px 0 0 30px;
  padding-left: 4px;
}

.progress-plan-mark.end-point {
  border-radius: 0 30px 30px 0;
  padding-right: 6px;
}

.arrow-right {
  display: none;
}
.end-point .arrow-right {
  display: unset;
  font-family: "Tahoma", sans-serif;
  margin-left: -8px;
  margin-top: -3px;
  user-select: none;
}
</style>
